webpackJsonp([2],{

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_success_inscription_vue__ = __webpack_require__(584);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7edf9be6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_success_inscription_vue__ = __webpack_require__(705);
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_success_inscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7edf9be6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_success_inscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-header'
});

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function phonePer() {
	return '+51 927 476 997';
}

function phoneEcu() {
	return '33730500 - +593 998548169';
}
function created() {
	this.linkFace = 'https://www.facebook.com/Mi-bodega--107633674246248/?modal=admin_todo_tour';
	this.linkInst = 'https://www.instagram.com/mibodegapp';
	this.numberCoupon = '50';
}

function data() {
	return {
		linkFace: '',
		linkInst: '',
		numberCoupon: 0
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'new-footer',
	data: data,
	computed: {
		phonePer: phonePer,
		phoneEcu: phoneEcu
	},
	created: created,
	props: {
		gray: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ffe485_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(403);
function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70ffe485"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ffe485_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'status',
	props: {
		img: String,
		textOne: String,
		textTwo: String
	}
});

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(402);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("5d57f7a4", content, true, {});

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".header[data-v-70ffe485]{background:#02979b;color:#fff;font-family:Lato;padding:40px 0 10px}.center[data-v-70ffe485]{text-align:center}.text[data-v-70ffe485]{font-weight:900}", "", {"version":3,"sources":["/opt/build/repo/src/components/pago/app-header.vue"],"names":[],"mappings":"AACA,yBACE,mBAAoB,AACpB,WAAe,AACf,iBAAoB,AACpB,mBAAuB,CACxB,AACD,yBACE,iBAAmB,CACpB,AACD,uBACE,eAAiB,CAClB","file":"app-header.vue","sourcesContent":["\n.header[data-v-70ffe485] {\n  background: #02979b;\n  color: #ffffff;\n  font-family: \"Lato\";\n  padding: 40px 0 10px 0;\n}\n.center[data-v-70ffe485] {\n  text-align: center;\n}\n.text[data-v-70ffe485] {\n  font-weight: 900;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"center mb-2"},[_c('button',{on:{"click":_vm.goToHome}},[_c('img',{attrs:{"src":(_vm.$S3 + "logo-mibodega-white.png"),"alt":"logo","height":"40"}})])]),_vm._v(" "),_c('p',{staticClass:"center text"},[_vm._v("Mi bodega, tu bodega.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_footer_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0170349e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_footer_vue__ = __webpack_require__(443);
function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0170349e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0170349e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(442);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("a2011bec", content, true, {});

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".new-footer[data-v-0170349e]{font-family:Lato}.new-footer .footer-logo[data-v-0170349e]{background-color:#b1dc03;padding:50px 7%}.new-footer .footer-logo.gray[data-v-0170349e]{background-color:#fafafa}.new-footer .btn-footer[data-v-0170349e]{background-color:#02979b;border-radius:9px;color:#fff;display:inline-block;font-size:18px;text-align:center;padding:13px 0;text-decoration:none;width:100%}@media (max-width:936px){.new-footer .btn-footer[data-v-0170349e]{display:block;margin:auto;max-width:227px;width:100%}}.new-footer .footer-link[data-v-0170349e]{align-items:center;background-color:#fff;border-radius:50%;display:flex;height:54px;justify-content:center;text-align:center;width:54px}.new-footer .footer-link.gray[data-v-0170349e]{background-color:#b1dc03}.new-footer .wrapper-btn[data-v-0170349e]{align-self:center}.new-footer .wrapper-information[data-v-0170349e]{color:#02979b;padding:40px 7% 0}@media (min-width:1350px){.new-footer .wrapper-information[data-v-0170349e]{padding:40px 0 0}}.new-footer .title[data-v-0170349e]{font-size:24px}.new-footer .link-direction[data-v-0170349e]{color:#02979b;display:inline-block;text-decoration:none}.new-footer .wrapper-end[data-v-0170349e]{background:#02979b;color:#fff;padding:14px;text-align:center}.new-footer .link[data-v-0170349e]{color:#fff;text-decoration:none}.new-footer .logo[data-v-0170349e]{height:89px}@media (max-width:936px){.new-footer .logo[data-v-0170349e]{height:auto;width:100%}}.new-footer .logo-cel[data-v-0170349e]{height:312px}@media (max-width:936px){.new-footer .logo-cel[data-v-0170349e]{height:auto;width:100%}}@media (max-width:936px){.new-footer .btn-networks[data-v-0170349e]{margin-top:50px}}@media (max-width:936px){.new-footer .btn-networks.right[data-v-0170349e]{text-align:right;padding-right:14px}}@media (max-width:936px){.new-footer .btn-networks.left[data-v-0170349e]{padding-left:14px}}@media (max-width:936px){.new-footer .link-m-right[data-v-0170349e]{margin-left:auto}}.new-footer .order-1[data-v-0170349e]{order:1}.new-footer .order-2[data-v-0170349e]{order:2}.wrapper-text-medium[data-v-0170349e]{align-items:center;display:flex;padding:0 20px}.wrapper-text-medium p[data-v-0170349e]{color:#085f65;font-size:24px;font-weight:600}.dis-flex[data-v-0170349e]{display:flex}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/new-footer.vue"],"names":[],"mappings":"AACA,6BACE,gBAAoB,CACrB,AACD,0CACI,yBAA0B,AAC1B,eAAiB,CACpB,AACD,+CACM,wBAA0B,CAC/B,AACD,yCACI,yBAA0B,AAC1B,kBAAmB,AACnB,WAAe,AACf,qBAAsB,AACtB,eAAgB,AAChB,kBAAmB,AACnB,eAAgB,AAChB,qBAAsB,AACtB,UAAY,CACf,AACD,yBACA,yCACQ,cAAe,AACf,YAAa,AACb,gBAAiB,AACjB,UAAY,CACnB,CACA,AACD,0CACI,mBAAoB,AACpB,sBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,YAAa,AACb,uBAAwB,AACxB,kBAAmB,AACnB,UAAY,CACf,AACD,+CACM,wBAA0B,CAC/B,AACD,0CACI,iBAAmB,CACtB,AACD,kDACI,cAAe,AACf,iBAAsB,CACzB,AACD,0BACA,kDACQ,gBAAoB,CAC3B,CACA,AACD,oCACI,cAAgB,CACnB,AACD,6CACI,cAAe,AACf,qBAAsB,AACtB,oBAAsB,CACzB,AACD,0CACI,mBAAoB,AACpB,WAAe,AACf,aAAc,AACd,iBAAmB,CACtB,AACD,mCACI,WAAe,AACf,oBAAsB,CACzB,AACD,mCACI,WAAa,CAChB,AACD,yBACA,mCACQ,YAAa,AACb,UAAY,CACnB,CACA,AACD,uCACI,YAAc,CACjB,AACD,yBACA,uCACQ,YAAa,AACb,UAAY,CACnB,CACA,AACD,yBACA,2CACM,eAAiB,CACtB,CACA,AACD,yBACA,iDACM,iBAAkB,AAClB,kBAAoB,CACzB,CACA,AACD,yBACA,gDACM,iBAAmB,CACxB,CACA,AACD,yBACA,2CACM,gBAAkB,CACvB,CACA,AACD,sCACI,OAAS,CACZ,AACD,sCACI,OAAS,CACZ,AACD,sCACE,mBAAoB,AACpB,aAAc,AACd,cAAgB,CACjB,AACD,wCACI,cAAe,AACf,eAAgB,AAChB,eAAiB,CACpB,AACD,2BACE,YAAc,CACf","file":"new-footer.vue","sourcesContent":["\n.new-footer[data-v-0170349e] {\n  font-family: \"Lato\";\n}\n.new-footer .footer-logo[data-v-0170349e] {\n    background-color: #b1dc03;\n    padding: 50px 7%;\n}\n.new-footer .footer-logo.gray[data-v-0170349e] {\n      background-color: #fafafa;\n}\n.new-footer .btn-footer[data-v-0170349e] {\n    background-color: #02979b;\n    border-radius: 9px;\n    color: #ffffff;\n    display: inline-block;\n    font-size: 18px;\n    text-align: center;\n    padding: 13px 0;\n    text-decoration: none;\n    width: 100%;\n}\n@media (max-width: 936px) {\n.new-footer .btn-footer[data-v-0170349e] {\n        display: block;\n        margin: auto;\n        max-width: 227px;\n        width: 100%;\n}\n}\n.new-footer .footer-link[data-v-0170349e] {\n    align-items: center;\n    background-color: #ffffff;\n    border-radius: 50%;\n    display: flex;\n    height: 54px;\n    justify-content: center;\n    text-align: center;\n    width: 54px;\n}\n.new-footer .footer-link.gray[data-v-0170349e] {\n      background-color: #b1dc03;\n}\n.new-footer .wrapper-btn[data-v-0170349e] {\n    align-self: center;\n}\n.new-footer .wrapper-information[data-v-0170349e] {\n    color: #02979b;\n    padding: 40px 7% 0 7%;\n}\n@media (min-width: 1350px) {\n.new-footer .wrapper-information[data-v-0170349e] {\n        padding: 40px 0 0 0;\n}\n}\n.new-footer .title[data-v-0170349e] {\n    font-size: 24px;\n}\n.new-footer .link-direction[data-v-0170349e] {\n    color: #02979b;\n    display: inline-block;\n    text-decoration: none;\n}\n.new-footer .wrapper-end[data-v-0170349e] {\n    background: #02979b;\n    color: #ffffff;\n    padding: 14px;\n    text-align: center;\n}\n.new-footer .link[data-v-0170349e] {\n    color: #ffffff;\n    text-decoration: none;\n}\n.new-footer .logo[data-v-0170349e] {\n    height: 89px;\n}\n@media (max-width: 936px) {\n.new-footer .logo[data-v-0170349e] {\n        height: auto;\n        width: 100%;\n}\n}\n.new-footer .logo-cel[data-v-0170349e] {\n    height: 312px;\n}\n@media (max-width: 936px) {\n.new-footer .logo-cel[data-v-0170349e] {\n        height: auto;\n        width: 100%;\n}\n}\n@media (max-width: 936px) {\n.new-footer .btn-networks[data-v-0170349e] {\n      margin-top: 50px;\n}\n}\n@media (max-width: 936px) {\n.new-footer .btn-networks.right[data-v-0170349e] {\n      text-align: right;\n      padding-right: 14px;\n}\n}\n@media (max-width: 936px) {\n.new-footer .btn-networks.left[data-v-0170349e] {\n      padding-left: 14px;\n}\n}\n@media (max-width: 936px) {\n.new-footer .link-m-right[data-v-0170349e] {\n      margin-left: auto;\n}\n}\n.new-footer .order-1[data-v-0170349e] {\n    order: 1;\n}\n.new-footer .order-2[data-v-0170349e] {\n    order: 2;\n}\n.wrapper-text-medium[data-v-0170349e] {\n  align-items: center;\n  display: flex;\n  padding: 0 20px;\n}\n.wrapper-text-medium p[data-v-0170349e] {\n    color: #085f65;\n    font-size: 24px;\n    font-weight: 600;\n}\n.dis-flex[data-v-0170349e] {\n  display: flex;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-footer"},[_c('v-layout',{staticClass:"footer-logo",class:{'gray': _vm.gray},attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"container",attrs:{"wrap":""}},[_c('v-flex',[_c('button',{on:{"click":_vm.goToHome}},[(_vm.gray)?_c('img',{staticClass:"logo",attrs:{"src":(_vm.$S3 + "logo-text-green.svg"),"alt":"logo"}}):_c('img',{staticClass:"logo",attrs:{"src":(_vm.$S3 + "logo-text.svg"),"alt":"logo"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"wrapper-btn"},[_c('v-layout',{attrs:{"justify-end":"","wrap":""}},[(!_vm.gray)?_c('v-flex',{attrs:{"xs12":"","md5":"","mr-4":""}},[_c('a',{staticClass:"btn-footer bold",attrs:{"href":"#banner"}},[_vm._v("Solicita tu app")])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"btn-networks right",attrs:{"xs6":"","md2":""}},[_c('a',{staticClass:"footer-link link-m-right",class:{'gray': _vm.gray},attrs:{"href":_vm.linkFace,"target":"_blank"}},[_c('img',{attrs:{"src":(_vm.$S3 + "facebook-logo.png"),"alt":"facebook","height":"25"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"btn-networks left",attrs:{"xs6":"","md2":""}},[_c('a',{staticClass:"footer-link",class:{'gray': _vm.gray},attrs:{"href":_vm.linkInst,"target":"_blank"}},[_c('img',{attrs:{"src":(_vm.$S3 + "instagram-logo.png"),"alt":"instagram","height":"25"}})])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"wrapper-information container",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{class:[_vm.isPeru ? 'order-1' : 'order-2'],attrs:{"xs12":""}},[_c('div',{staticClass:"mb-5"},[_c('p',{staticClass:"title bold"},[_vm._v("Perú")]),_vm._v(" "),_c('a',{staticClass:"bold link-direction mb-2",attrs:{"href":"https://goo.gl/maps/8vAGxHq1v49WAxj26","target":"_back"}},[_vm._v("Lima")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.phonePer)),_c('br'),_vm._v("Calle Independencia  106, Piso 10 "),_c('br'),_vm._v("Miraflores")])])]),_vm._v(" "),_c('v-flex',{class:[!_vm.isPeru ? 'order-1' : 'order-2'],attrs:{"xs12":""}},[_c('div',[_c('p',{staticClass:"title bold"},[_vm._v("Ecuador")]),_vm._v(" "),_c('a',{staticClass:"bold link-direction mb-2",attrs:{"href":"https://www.google.com/maps/search/Pinta+236+y+R%C3%A1bida.+Edif.+La+Pinta/@-0.1992127,-78.4896696,18z","target":"_blank"}},[_vm._v("Latacunga")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.phoneEcu)),_c('br'),_vm._v("AV. UNIDAD NACIONAL Y GABRIELA MISTRAL. EDIF. FENIX CORP. "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\tMatríz Centro Tecnológico Latacunga\n\t\t\t\t\t\t")])])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"dis-flex",attrs:{"xs12":"","md3":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"wrapper-text-medium",attrs:{"xs12":""}},[_c('p',{staticClass:"mb-0"},[_vm._v("Tenemos un regalo para los primeros "+_vm._s(_vm.numberCoupon)+" negocios validados.")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('img',{staticClass:"logo-cel",attrs:{"src":(_vm.$S3 + "phone-app-screen-footer-min.png"),"alt":"imagen celular"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_status_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7424ea21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_status_vue__ = __webpack_require__(447);
function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7424ea21"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_status_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7424ea21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(446);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("641855c3", content, true, {});

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".center[data-v-7424ea21]{text-align:center}.wrapper-status[data-v-7424ea21]{color:#8f8f8f;font-weight:900;font-size:25px;padding:85px 0}.text-green[data-v-7424ea21]{color:#02979b;font-size:28px}", "", {"version":3,"sources":["/opt/build/repo/src/components/pago/status.vue"],"names":[],"mappings":"AACA,yBACE,iBAAmB,CACpB,AACD,iCACE,cAAe,AACf,gBAAiB,AACjB,eAAgB,AAChB,cAAgB,CACjB,AACD,6BACE,cAAe,AACf,cAAgB,CACjB","file":"status.vue","sourcesContent":["\n.center[data-v-7424ea21] {\n  text-align: center;\n}\n.wrapper-status[data-v-7424ea21] {\n  color: #8f8f8f;\n  font-weight: 900;\n  font-size: 25px;\n  padding: 85px 0;\n}\n.text-green[data-v-7424ea21] {\n  color: #02979b;\n  font-size: 28px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-status"},[_c('div',{staticClass:"center mb-4"},[_c('img',{attrs:{"src":_vm.img,"alt":"imagen","height":"68"}})]),_vm._v(" "),_c('p',{staticClass:"center"},[_c('span',{staticClass:"text-green"},[_vm._v("TU PAGO")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.textOne))]),_vm._v(" "),_c('span',{staticClass:"text-green"},[_vm._v(_vm._s(_vm.textTwo))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pago_app_header__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_new_footer__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generate_app_section_success__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pago_status__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generate_app_section_payment__ = __webpack_require__(701);
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-pago-exitoso',
	components: {
		headerPago: __WEBPACK_IMPORTED_MODULE_0__components_pago_app_header__["a" /* default */],
		newFooter: __WEBPACK_IMPORTED_MODULE_1__components_home_new_footer__["a" /* default */],
		sectionSuccess: __WEBPACK_IMPORTED_MODULE_2__components_generate_app_section_success__["a" /* default */],
		status: __WEBPACK_IMPORTED_MODULE_3__components_pago_status__["a" /* default */],
		sectionPayment: __WEBPACK_IMPORTED_MODULE_4__components_generate_app_section_payment__["a" /* default */]
	},
	props: {
		fullName: String
	}
});

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function created() {
	this.linkPayment = this.isPeru ? 'https://www.mercadopago.com.pe/checkout/v1/redirect?pref_id=547381162-58dab07e-3509-4b09-8fc3-90be611d9265' : '#section-payment';
}

function data() {
	return {
		linkGooglePlay: 'https://play.google.com/store/apps/details?id=com.quipu.makipos.bodega',
		linkPayment: '',
		linkAdmin: 'https://admin.mibodega.net'
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-success',
	created: created,
	data: data,
	props: {
		fullName: String
	}
});

/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-payment'
});

/***/ }),

/***/ 697:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_success_vue__ = __webpack_require__(585);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2845c43a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_success_vue__ = __webpack_require__(700);
function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2845c43a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_success_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2845c43a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_success_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(699);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("167b26d1", content, true, {});

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".center[data-v-2845c43a]{text-align:center}.wrapper-status[data-v-2845c43a]{color:#02979b;font-family:Lato;font-size:36px;font-weight:900;padding:137px 0 85px}.wrapper-btns[data-v-2845c43a]{display:flex;justify-content:center}.link[data-v-2845c43a]{background:#b1dc03;border-radius:7px;display:inline-block;color:#02979b;font-family:Lato;font-size:23px;font-weight:900;height:72px;line-height:50px;margin-right:20px;padding:8px;text-decoration:none;text-align:center;width:253px}.span-text[data-v-2845c43a]{color:#8f8f8f}.btn-google-play[data-v-2845c43a]{margin-top:8px;width:253px}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/section-success.vue"],"names":[],"mappings":"AACA,yBACE,iBAAmB,CACpB,AACD,iCACE,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,oBAAwB,CACzB,AACD,+BACE,aAAc,AACd,sBAAwB,CACzB,AACD,uBACE,mBAAoB,AACpB,kBAAmB,AACnB,qBAAsB,AACtB,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,YAAa,AACb,qBAAsB,AACtB,kBAAmB,AACnB,WAAa,CACd,AACD,4BACE,aAAe,CAChB,AACD,kCACE,eAAgB,AAChB,WAAa,CACd","file":"section-success.vue","sourcesContent":["\n.center[data-v-2845c43a] {\n  text-align: center;\n}\n.wrapper-status[data-v-2845c43a] {\n  color: #02979b;\n  font-family: \"Lato\";\n  font-size: 36px;\n  font-weight: 900;\n  padding: 137px 0px 85px;\n}\n.wrapper-btns[data-v-2845c43a] {\n  display: flex;\n  justify-content: center;\n}\n.link[data-v-2845c43a] {\n  background: #b1dc03;\n  border-radius: 7px;\n  display: inline-block;\n  color: #02979b;\n  font-family: \"Lato\";\n  font-size: 23px;\n  font-weight: 900;\n  height: 72px;\n  line-height: 50px;\n  margin-right: 20px;\n  padding: 8px;\n  text-decoration: none;\n  text-align: center;\n  width: 253px;\n}\n.span-text[data-v-2845c43a] {\n  color: #8f8f8f;\n}\n.btn-google-play[data-v-2845c43a] {\n  margin-top: 8px;\n  width: 253px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-status text-xs-center"},[_c('img',{staticClass:"mb-5",attrs:{"src":"/static/images/icons/checked-1.svg","alt":"","height":"68"}}),_vm._v(" "),_c('p',{staticClass:"center mb-5"},[_vm._v("\n\t\tGracias "+_vm._s(_vm.fullName)+", "),_c('span',{staticClass:"span-text"},[_vm._v("por ser parte de")]),_vm._v(" MIBODEGA.\n\t")]),_vm._v(" "),_c('v-layout',{staticClass:"wrapper-btns mb-4",attrs:{"row":"","wrap":"","align-center":""}},[_c('div',[_c('a',{staticClass:"link",attrs:{"href":_vm.linkAdmin,"target":"_blank"}},[_vm._v("\n\t\t\t\tIr al administrador\n\t\t\t")])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"link",attrs:{"href":_vm.linkPayment,"target":_vm.isPeru ? '_blank' : ''}},[_vm._v("\n\t\t\t\tRealizar pago\n\t\t\t")])]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":_vm.linkGooglePlay,"target":"_blank"}},[_c('img',{staticClass:"btn-google-play",attrs:{"src":(_vm.$S3 + "icon-google.png"),"alt":"google play","height":"106"}})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_payment_vue__ = __webpack_require__(586);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d847ace_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_payment_vue__ = __webpack_require__(704);
function injectStyle (ssrContext) {
  __webpack_require__(702)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d847ace"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d847ace_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(703);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("a01b63aa", content, true, {});

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-payment[data-v-2d847ace]{background:#f2f6f7;padding:60px 7%}.text-payment[data-v-2d847ace]{color:#02979b;font-size:30px;font-weight:600;text-align:center}.wrapper-payment[data-v-2d847ace]{border-radius:18px;box-shadow:0 2px 20px 0 rgba(0,0,0,.06);background:#fff;color:#8f8f8f;margin:auto;font-size:20px;padding:20px;width:290px}.text-bank[data-v-2d847ace]{font-weight:600}.text-num[data-v-2d847ace]{color:#085f65;font-weight:600}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/section-payment.vue"],"names":[],"mappings":"AACA,kCACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,+BACE,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACpB,AACD,kCACE,mBAAoB,AACpB,wCAA6C,AAC7C,gBAAoB,AACpB,cAAe,AACf,YAAa,AACb,eAAgB,AAChB,aAAc,AACd,WAAa,CACd,AACD,4BACE,eAAiB,CAClB,AACD,2BACE,cAAe,AACf,eAAiB,CAClB","file":"section-payment.vue","sourcesContent":["\n.section-payment[data-v-2d847ace] {\n  background: #f2f6f7;\n  padding: 60px 7%;\n}\n.text-payment[data-v-2d847ace] {\n  color: #02979b;\n  font-size: 30px;\n  font-weight: 600;\n  text-align: center;\n}\n.wrapper-payment[data-v-2d847ace] {\n  border-radius: 18px;\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.06);\n  background: #ffffff;\n  color: #8f8f8f;\n  margin: auto;\n  font-size: 20px;\n  padding: 20px;\n  width: 290px;\n}\n.text-bank[data-v-2d847ace] {\n  font-weight: 600;\n}\n.text-num[data-v-2d847ace] {\n  color: #085f65;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 704:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-payment",attrs:{"id":"section-payment"}},[_c('p',{staticClass:"text-payment"},[_vm._v("El pago lo puedes realizar a través de:")]),_vm._v(" "),_c('div',{staticClass:"wrapper-payment"},[_c('p',{staticClass:"text-bank"},[_vm._v("BANCO INTERNACIONAL")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("Cuenta corriente:")]),_vm._v(" "),_c('p',{staticClass:"text-num"},[_vm._v("Nº: 3500613691")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("QUIPUSOFT S.A "),_c('br'),_vm._v("RUC: 1792997178001")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-pago'),_vm._v(" "),_c('section-success',{attrs:{"full-name":_vm.fullName}}),_vm._v(" "),(!_vm.isPeru)?_c('section-payment'):_vm._e(),_vm._v(" "),_c('new-footer',{attrs:{"gray":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.aea09bebc67f4b362e9b.js